import React from 'react';
import { NavLink } from 'react-router-dom';

import { useSidebar } from '../app/providers';

import { SidebarItemConfig } from './sidebarConfig';

interface SidebarItemProps {
    item: SidebarItemConfig;
    isNested?: boolean;
    badgeCount?: number | undefined;
}

const SidebarItem: React.FC<SidebarItemProps> = ({ item, isNested = false, badgeCount }) => {
    const { isCollapsed, closeMobile } = useSidebar();
    const Icon = item.icon;

    const handleClick = () => {
        // Close mobile sidebar when navigating
        closeMobile();
    };

    return (
        <NavLink
            to={item.path}
            onClick={handleClick}
            end={item.path === '/admin'}
            className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200
        ${isNested ? 'ml-4' : ''}
        ${isActive
                    ? 'bg-primary text-white shadow-sm'
                    : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900'
                }
        ${isCollapsed && !isNested ? 'justify-center px-2' : ''}
        `
            }
        >
            {Icon && (
                <Icon
                    size={isNested ? 16 : 18}
                    className="flex-shrink-0"
                />
            )}
            {(!isCollapsed || isNested) && (
                <span className={`font-medium ${isNested ? 'text-sm' : 'text-sm'}`}>
                    {item.label}
                </span>
            )}
            {!isCollapsed && typeof badgeCount === 'number' && badgeCount > 0 && (
                <span className="ml-auto inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-amber-100 px-1.5 text-xs font-semibold text-amber-800">
                    {badgeCount}
                </span>
            )}
        </NavLink>
    );
};

export default SidebarItem;
